"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setFillColor = void 0;
const setFillColor = (element, color) => {
    const paths = element.getElementsByTagName('path');
    const arrayPaths = Array.from(paths);
    arrayPaths.forEach((path) => {
        path.setAttribute('fill', color);
    });
};
exports.setFillColor = setFillColor;
